import { createAsyncThunk } from "@reduxjs/toolkit";

/**
 * Async thunk for logout with navigation
 * This allows side effects like navigation while maintaining Redux patterns
 */
export const logoutWithRedirect = createAsyncThunk(
  "auth/logoutWithRedirect",
  async (_, { dispatch }) => {
    // Clear localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("auth_state");
    
    // Reset auth state
    const newState = { 
      me: {
        id: null,
        name: null,
        email: null,
        numeroInscricao: null,
        cpf: null,
        cellphone: null,
        role: null,
        nameSocial: null,
        fotos: [],
        image: null,
        empresa: null
      },
      loading: false,
      logged: false,
      status: "1111",
      errorMessage: "",
      errors: [],
      token: null,
      blank: false,
      shouldRedirectToLogin: false // No need for flag since we navigate directly
    };
    
    // Navigate to login - this will be handled in the component
    return { shouldNavigate: true, newState };
  }
);
